import { memo } from "react";
import { navElements } from "../../../constants";
import { ActiveElement, NavbarProps } from "../../../types/type";
import { Button } from "../../ui/button";
import ShapesMenu from "./shapes-menu";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { siteSettings } from "../../../settings/site-settings";

const Navbar = ({
  activeElement,
  imageInputRef,
  handleImageUpload,
  handleActiveElement,
  saveTemplate,
  handleSvgUpload,
  svgInputRef,
  isSavingTemplate,
}: NavbarProps) => {
  const navigate = useNavigate();

  const isActive = (value: string | Array<ActiveElement>) =>
    (activeElement && activeElement.value === value) ||
    (Array.isArray(value) &&
      value.some((val) => val?.value === activeElement?.value));

  const handlePushBack = () => {
    navigate(-1);
  };

  return (
    <nav className="flex select-none h-[48px] items-center justify-between gap-2 bg-blackLight px-5 text-white">
      <div className="w-1/3 h-full flex items-center">
        <FaArrowLeftLong
          size={22}
          onClick={handlePushBack}
          title="Back"
          className="me-5 hover:text-primary hover:cursor-pointer"
        />

        {/* <p className="font-bold text-lg">{siteSettings.siteName}</p> */}
        <img src={siteSettings.logo} alt="logo" className="h-7 /ml-2" />
      </div>

      <ul className="flex h-full w-full justify-center items-center">
        {navElements.map((item: ActiveElement | any) => {
          const IconComponent = item.icon;
          return (
            <li
              key={item.name}
              title={item.name}
              onClick={() => {
                if (Array.isArray(item.value)) return;
                handleActiveElement(item);
              }}
              className={`group w-14 h-full flex justify-center items-center cursor-pointer transition-colors duration-200
            ${isActive(item.value) ? "bg-primary text-white" : "hover:bg-black"}
            `}
            >
              {Array.isArray(item.value) ? (
                <ShapesMenu
                  item={item}
                  activeElement={activeElement}
                  imageInputRef={imageInputRef}
                  handleActiveElement={handleActiveElement}
                  handleImageUpload={handleImageUpload}
                  svgInputRef={svgInputRef}
                  handleSvgUpload={handleSvgUpload}
                />
              ) : (
                <div className="relative w-full h-full flex items-center justify-center ">
                  <IconComponent alt={item.name} size={18} />
                </div>
              )}
            </li>
          );
        })}
      </ul>

      <div className="w-1/3 h-full flex items-center justify-end">
        <Button
          onClick={() => {
            saveTemplate();
          }}
          loading={isSavingTemplate}
          className="w-24 h-8"
        >
          Save
        </Button>
      </div>
    </nav>
  );
};

export default memo(
  Navbar,
  (prevProps, nextProps) =>
    prevProps.activeElement === nextProps.activeElement &&
    prevProps.isSavingTemplate === nextProps.isSavingTemplate
);

// export default Navbar;
